var exports = {
  "G": "xfb577c5e--f028a5--social-links",
  "W": "xfb577c5e--f028a5--input-link",
  "vk": "xfb577c5e--f028a5--vk",
  "ok": "xfb577c5e--f028a5--ok",
};

module.exports = exports;
